'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DescriptionInput = require('./components/DescriptionInput.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DescriptionInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/description-input/index.js
// module id = 1036
// module chunks = 0